import { render, staticRenderFns } from "./DocEdit.vue?vue&type=template&id=6a759e61&scoped=true&"
import script from "./DocEdit.vue?vue&type=script&lang=js&"
export * from "./DocEdit.vue?vue&type=script&lang=js&"
import style0 from "./DocEdit.vue?vue&type=style&index=0&id=6a759e61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a759e61",
  null
  
)

export default component.exports